import { useLanguage } from "@/context/LanguageContext";
import { Chapter, Reveal } from "@/components/atoms";

export const Einsatz = () => {
  const { t } = useLanguage();
  const e = t.einsatz;
  return (
    <section id="einsatz" className="border-t border-hairline" data-testid="einsatz-section">
      <div className="px-5 md:px-10 pt-20 md:pt-28 pb-12 md:pb-16">
        <Reveal>
          <Chapter num={e.chapter} label={e.label} />
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-10 font-serif font-light tracking-tight leading-none text-4xl sm:text-5xl md:text-6xl" data-testid="einsatz-headline">
            {e.headline}
          </h2>
        </Reveal>
      </div>
      <div className="border-t border-hairline grid md:grid-cols-2 gap-px bg-hairline" data-testid="einsatz-grid">
        {e.areas.map((area, i) => (
          <Reveal key={i} delay={0.06 * i} className="bg-paper">
            <div className="p-8 md:p-12 h-full transition-colors duration-500 hover:bg-cardboard/60" data-testid={`einsatz-cell-${i}`}>
              <span className="font-mono text-[11px] tracking-[0.25em] text-proof">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="mt-5 font-serif text-2xl md:text-3xl tracking-tight">{area.title}</h3>
              <p className="mt-4 text-base md:text-lg font-light leading-relaxed text-ink/80">{area.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
